import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import * as actions from '../../actions';
import ProfileList from '../../components/ProfileList';
import PortalBanner from "../../components/PortalBanner/index";
import LoadSpinner from "../../components/LoadSpinner/index";
import tiaraClickSender from "../../utils/tiaraClickSender";

export class ProfileEventPage extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.fetchProfiles = this.fetchProfiles.bind(this);
    this.state = {
      isFetching: false,
      profileRenderCount: 20
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const container = ReactDOM.findDOMNode(this);
    if (window.pageYOffset + window.innerHeight >= container.offsetHeight + container.offsetTop) {
      this.fetchProfiles();
    }
  }

  fetchProfiles() {
    const { event } = this.props;
    const { profileRenderCount, isFetching } = this.state;
    const profiles = event.get('profiles') || Immutable.List();
    if (isFetching || profiles.size <= profileRenderCount) {
      return;
    }
    this.setState({ isFetching: true });
    setTimeout(() => {
      this.setState({
        isFetching: false,
        profileRenderCount: this.state.profileRenderCount + 20
      });
    }, 50);
  }
  
  render() {
    const { device, event, isFromPortalMain } = this.props;
    const { isFetching, profileRenderCount } = this.state;
    return (
      <div>
        <header id="kakaoHead">
          <h1 className="screen_out">카카오톡 채널</h1>
        </header>
        <hr className="hide" />
        <main id="kakaoContent">
          <article id="mArticle">
            <div>
              <h2 className="screen_out">배너 상세</h2>
              <div className="box_plus">
                <PortalBanner event={event} isInnerType={Boolean(true)} />
              </div>
              {!isFromPortalMain && (
                <a href="/portal" className="link_made link_made2" data-tiara-layer="pf_more">
                  <strong className="tit_made">
                    <span className="ico_plus ico_logo" />더 많은 채널을 만나보세요<span className="ico_plus ico_arr" />
                  </strong>
                </a>
              )}
              <div data-tiara-layer="event_page">
                <ProfileList
                  device={device}
                  profiles={event.get('profiles')}
                  isNoTitle={Boolean(true)}
                  useRenderCount={Boolean(true)}
                  renderCount={profileRenderCount}
                />
              </div>
              <LoadSpinner isFetching={isFetching}/>
            </div>
          </article>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state, {}) => {
  const { device, entities } = state;
  const event = entities.get('event') || Immutable.Map();
  const isFromPortalMain = entities.get('isFromPortalMain') || false;
  return { device, event, entities, isFromPortalMain };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    showModal: actions.showModal
  }, dispatch)
)(tiaraClickSender(ProfileEventPage));


// WEBPACK FOOTER //
// ./src/containers/ProfileEventPage/index.js